
    import __i18nConfig from '@next-translate-root/i18n.js'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import CheckIcon from "@mui/icons-material/Check";
import { Box, List, ListItem, ListItemIcon, ListItemText, useMediaQuery, useTheme, } from "@mui/material";
import { Accordion, Grid, Image, Link, Meta, Typography } from "@/components/core";
const accordionStyle = { width: { xs: 750, md: 750 } };
const listItemStyle = { alignItems: "flex-start", px: 0 };
const listItemIconStyle = { minWidth: "35px", mt: "4px" };
const iconStyle = { color: "#000", fontSize: "20px" };
export default function Index() {
    const theme = useTheme();
    const mobileMediaQuery = theme.breakpoints.down("md");
    const isMobileDevice = useMediaQuery(mobileMediaQuery);
    return (<Box sx={isMobileDevice
            ? {}
            : {
                backgroundImage: "url('/images/blue-bg.png')",
                backgroundRepeat: "no-repeat",
                backgroundSize: "cover",
                width: "auto",
                height: "100vh",
                flexDirection: "row",
            }}>
      <Meta title="UPTION Tüzel Web Şube - Sık Sorulan Sorular"/>
      <Grid.Item xs={6} sx={{
            display: { xs: "block" },
            padding: 3,
            paddingBottom: 0,
            flexDirection: "row",
        }}>
        <Link href="/">
          <Image width={160} height={40} src="/svg/logo-white.svg" priority/>
        </Link>
      </Grid.Item>
      <Grid.Item xs={12} sx={{ display: "flex", justifyContent: "center", mt: 0 }}>
        <Typography variant="h5" sx={{ color: "white" }}>
          Yardıma mı ihtiyacınız var?
        </Typography>
      </Grid.Item>
      <Grid.Item xs={6} sx={{
            display: "flex",
            justifyContent: "center",
            mt: 2,
            flexDirection: "column",
        }}>
        <Accordion sx={accordionStyle} summary="Kurumsal UPTION Nedir?" details="UPTION Kurumsal, Aktif Bank iştiraki UPT Ödeme Hizmetleri ve Elektronik Para A.Ş. tarafından sunulan; kurumsal müşterilerin uluslararası para transferi işlemlerini hızlı, güvenli ve kolay bir şekilde gerçekleştirmelerine imkân tanıyan bir finansal hizmet çözümüdür."/>
        <Accordion sx={accordionStyle} summary="Kurumsal UPTION Web Sitesi Nedir?" details={<span>
              <Link href="/">www.kurumsalinternetsubesi.uption.com.tr</Link> adresinden web sitemize
              erişebilirsiniz.
            </span>}/>
        <Accordion sx={accordionStyle} summary="Kimler Kurumsal UPTION Müşterisi olabilir?" details="Kurumsal UPTION hizmetinden; şahıs şirketleri ile tüzel kişiliğe sahip tüm işletmeler yararlanabilmektedir."/>
        <Accordion sx={accordionStyle} summary="Kurumsal UPTION üzerinden nasıl para gönderebilirim?" details="Kurumsal UPTION üzerinden para transferi gerçekleştirmek için, kurumsal internet şubesine tanımlı kullanıcı adı ve şifreniz ile giriş yapmanız yeterlidir. Giriş yaptıktan sonra ilgili adımları takip ederek transfer işlemlerinizi kolayca tamamlayabilirsiniz."/>
        <Accordion sx={accordionStyle} summary="Transfer işlemleri ne kadar sürede tamamlanır?" details="Transfer işlemlerinin tamamlanma süresi; transferin türüne, gönderim yapılan ülkeye ve ilgili operasyonel süreçlere bağlı olarak değişiklik gösterebilmektedir."/>
        <Accordion sx={accordionStyle} summary="Kurumsal UPTION’In avantajları nelerdir?" details="Kurumsal UPTION, hızlı ve güvenli uluslararası para transferi imkânını avantajlı ücretlerle sunar."/>
        <Accordion sx={accordionStyle} summary="Kurumsal UPTION hesabıma nasıl para gönderebilirim?" details="Kurumsal UPTION hesabınıza para aktarımı, Türkiye’deki tüm bankalar üzerinden TL hesaplarına yapılabilmektedir. Euro ve dolar hesaplarına transferler ise yalnızca VakıfBank ve Türkiye Finans aracılığıyla gerçekleştirilmektedir."/>
        <Accordion sx={accordionStyle} summary="Kurumsal UPTION hesabımdan nasıl para çekerim?" details="Kurumsal UPTION üzerindeki TL hesaplarınızdan FAST/EFT işlemi gerçekleştirebilirsiniz."/>
        <Accordion sx={accordionStyle} summary="Kurumsal UPTION’dan hangi ülkelere para gönderebilirim?" details="Kurumsal UPTION üzerinden, ücretler sayfasında listelenen ülkelere para gönderme işlemlerinizi gerçekleştirebilirsiniz."/>
        <Accordion sx={accordionStyle} summary="Kurumsal UPTION’dan hangi para birimlerinde hesap açabilirim?" details="Kurumsal UPTION’da Türk Lirası (TRY), Euro (EUR) ve Amerikan Doları (USD) cinsinden hesap açabilirsiniz."/>
        <Accordion sx={accordionStyle} summary="Kurumsal UPTION işlem limitleri nedir?" details="İşlem limitleri günlük 35.000 EUR (veya karşılığı TL), aylık ise 350.000 EUR olarak uygulanmaktadır."/>
        <Accordion sx={accordionStyle} summary="Kurumsal UPTION şifremi unuttum/ şifre bloke oldu, ne yapmalıyım?" details="Şifre işlemlerinizle ilgili destek almak için kurumsalsube@upt.com.tr e-posta adresi üzerinden bizimle iletişime geçebilirsiniz. Talebiniz en kısa sürede değerlendirilerek tarafınıza geri dönüş sağlanacaktır."/>
        <Accordion sx={accordionStyle} summary="Kurumsal UPTION sözleşme şartları nelerdir?" details={<span>
              Sözleşme şartlarımıza{" "}
              <Link href="/agreement" target="_blank">
                buraya
              </Link>{" "}
              tıklayarak ulaşabilir ve detaylı olarak inceleyebilirsiniz.
            </span>}/>
        <Accordion sx={accordionStyle} summary="Kurumsal UPTION müşterisi olmak için gerekli belgeler nelerdir?" details={<List sx={{ width: "100%", py: 0 }}>
              <ListItem key="1" sx={listItemStyle}>
                <ListItemIcon sx={listItemIconStyle}>
                  <CheckIcon sx={iconStyle}/>
                </ListItemIcon>
                <ListItemText primary="Ticaret Sicil Gazetesi (TSG)"/>
              </ListItem>
              <ListItem key="2" sx={listItemStyle}>
                <ListItemIcon sx={listItemIconStyle}>
                  <CheckIcon sx={iconStyle}/>
                </ListItemIcon>
                <ListItemText primary="Vergi Levhası"/>
              </ListItem>
              <ListItem key="3" sx={listItemStyle}>
                <ListItemIcon sx={listItemIconStyle}>
                  <CheckIcon sx={iconStyle}/>
                </ListItemIcon>
                <ListItemText primary="Ticaret Odası Kayıt Belgesi ya da Faaliyet Belgesi (güncel tarihli)"/>
              </ListItem>
              <ListItem key="4" sx={listItemStyle}>
                <ListItemIcon sx={listItemIconStyle}>
                  <CheckIcon sx={iconStyle}/>
                </ListItemIcon>
                <ListItemText primary="Şirket Ana Sözleşmesi"/>
              </ListItem>
              <ListItem key="5" sx={listItemStyle}>
                <ListItemIcon sx={listItemIconStyle}>
                  <CheckIcon sx={iconStyle}/>
                </ListItemIcon>
                <ListItemText primary="İmza Sirküleri"/>
              </ListItem>
              <ListItem key="6" sx={listItemStyle}>
                <ListItemIcon sx={listItemIconStyle}>
                  <CheckIcon sx={iconStyle}/>
                </ListItemIcon>
                <ListItemText primary="Firmaya Yetkili Kişilerin, Şirket Ortaklarının Kimlik Kopyaları (Yabancı ise Pasaport Kopyaları)"/>
              </ListItem>
              <ListItem key="7" sx={listItemStyle}>
                <ListItemIcon sx={listItemIconStyle}>
                  <CheckIcon sx={iconStyle}/>
                </ListItemIcon>
                <ListItemText primary="Yetkililere Ait İletişim Numarası"/>
              </ListItem>
              <ListItem key="8" sx={listItemStyle}>
                <ListItemIcon sx={listItemIconStyle}>
                  <CheckIcon sx={iconStyle}/>
                </ListItemIcon>
                <ListItemText primary="Yetkililerin Adres Kayıt Belgeleri"/>
              </ListItem>
              <ListItem key="9" sx={listItemStyle}>
                <ListItemIcon sx={listItemIconStyle}>
                  <CheckIcon sx={iconStyle}/>
                </ListItemIcon>
                <ListItemText primary="Vergi Kimlik Numarasının Teyidini Sağlamak Üzere Gelir İdaresi Başkanlığının İlgili Birimi Tarafından Düzenlenen Belge"/>
              </ListItem>
              <ListItem key="10" sx={listItemStyle}>
                <ListItemIcon sx={listItemIconStyle}>
                  <CheckIcon sx={iconStyle}/>
                </ListItemIcon>
                <ListItemText primary="Adli sicil kayıtları"/>
              </ListItem>
            </List>}/>
      </Grid.Item>
      <Grid.Item xs={6} sx={{
            display: "flex",
            justifyContent: "center",
            mt: 2,
            flexDirection: "column",
        }}>
        <Typography sx={{ backgroundColor: "#ddd", p: 3, borderRadius: 5 }}>
          Mail adresi: <Link href="mailto:kurumsalsube@upt.com.tr">kurumsalsube@upt.com.tr</Link>
        </Typography>
      </Grid.Item>
    </Box>);
}

    async function __Next_Translate__getStaticProps__1a16af5a8d8__(ctx) {
      if (typeof global !== 'undefined') {
        global.i18nConfig = __i18nConfig
      }
      
      return {
        
        
        props: {
          
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: '/sss/index',
            loaderName: 'getStaticProps',
            loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || (() => Promise.resolve({})),
          }))
        }
      }
    }
    export { __Next_Translate__getStaticProps__1a16af5a8d8__ as getStaticProps }
  